import { Box, Typography } from '@mui/material';

import { toggleBoxStyle, toggleBoxStyleSelected } from './ToggleBox.styles';
import { ToggleBoxProps } from './ToggleBox.types';

export const ToggleBox = ({
  onSelected,
  label,
  selected,
  style,
}: any) => {
  return (
    <Box
      sx={[
        toggleBoxStyle,
        selected === label ? toggleBoxStyleSelected : null,
        style,
      ]}
      onClick={() => onSelected(label)}
    >
      <Typography fontSize={14}>{label}</Typography>
    </Box>
  );
}
